import React, { useState, useEffect } from "react";
import { userApi } from "../../../backend_urls/userApi";
import LoadingSpinner from "../../../components/loaders/LoadingSpinner";
import ModalPopup from "../../../components/popups/DefaultPopUp";
import ReusableForm from "../../../components/reusable/ReusableForm";
import BaseIcon from "../../../components/svg_icons/BaseIcon";
import "../../../css/pages/user_pages/modals/ManageBusiness.css";
import { Link } from "react-router-dom";
import { UserURL } from "../../../routes/user_routes/UserURL";

const ManageBusiness = () => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [selectedBusiness, setSelectedBusiness] = useState(null);

    const [openCreatePopUp, setOpenCreatePopUp] = useState(false);
    const [openDeletePopUp, setOpenDeletePopUp] = useState(false);
    const [openEditPopUp, setOpenEditPopUp] = useState(false);
    const [editBusiness, setEditBusiness] = useState(null);

    const fetchData = async () => {
        try {
            setLoading(true);
            const res = await userApi.getAllBusiness();
            const sorted = res.data.sort(
                (a, b) => new Date(b.created_at) - new Date(a.created_at)
            );
            setData(sorted);
        } catch (error) { console.error("Error fetching invoices:", error);
        } finally { setLoading(false); };
    };
    useEffect(() => { fetchData(); }, []);

    const handleAddBusiness = () => { setOpenCreatePopUp(true); };

    const handleSubmit = async (formData) => {
        setLoading(true);
        const finalPayload = { ...formData };
        await userApi.createNewBusiness(finalPayload);
        fetchData();
        setOpenCreatePopUp(false);
        setLoading(false);
    };

    const handleEdit = (business) => {
        setEditBusiness(business);
        setOpenEditPopUp(true);
    };
    const handleUpdate = async (formData) => {
        try {
            setLoading(true);
            await userApi.updateBusiness(editBusiness.id, formData);
            fetchData();
            setOpenEditPopUp(false);
            setEditBusiness(null);
        } catch (error) { console.error("Update failed", error);
        } finally { setLoading(false); }
    };

    const handleDelete = (business) => {
        setSelectedBusiness(business);
        setOpenDeletePopUp(true);
    };
    const confirmDelete = async () => {
        try {
            setLoading(true);
            await userApi.deleteBusiness(selectedBusiness.id);
            fetchData();
        } catch (error) { console.error("Delete failed", error);
        } finally {
            setOpenDeletePopUp(false);
            setLoading(false);
            setSelectedBusiness(null);
        }
    };

    return ( loading ? <LoadingSpinner /> :
        <>
            <div className="add-business-dashboard">
                {/* HEADER */}
                <div className="add-business-dashboard-header">
                    <div>
                        <h2>Your Businesses</h2>
                        <p className="add-business-subtitle">
                            Manage and track all your registered businesses
                        </p>
                    </div>

                    <button className="add-business-btn" onClick={handleAddBusiness}>
                        + Add Business
                    </button>
                </div>

                {/* STATS CARD */}
                <div className="stats-card">
                    <h3>{data.length}</h3>
                    <p>Total Businesses</p>
                </div>

                {/* LIST OR EMPTY STATE */}
                {data.length === 0 ? (
                    <div className="empty-state">
                        <h4>No businesses added yet</h4>
                        <p>Start by adding your first business to continue</p>
                        <button className="add-business-btn" onClick={handleAddBusiness}>
                            Add Your First Business
                        </button>
                    </div>
                ) : (
                    <div className="business-list">
                        {data.map((business, index) => (
                            <Link
                                to={UserURL.user_business_hub(business.id)}
                                style={{ textDecoration: "none" }}
                            >
                                <div key={index} className="business-card">
                                    <div>
                                        <h4>{business.business_name}</h4>
                                        <p>{business.business_address}</p>
                                    </div>

                                    <div className="meta">
                                        <span>GST: {business.gstin}</span>
                                        <span>State: {business.state_code}</span>
                                    </div>
                                    <div className="business-card-actions">
                                        <button className="edit" onClick={() => handleEdit(business)}>
                                            <BaseIcon name = "eyeOpen" />
                                        </button>
                                        <button className="delete" onClick={() => handleDelete(business)}>
                                            <BaseIcon name = "trash" />
                                        </button>
                                    </div>
                                </div>
                            </Link>
                        ))}
                    </div>
                )}
            </div>

            {/* Create Form */}
            <ReusableForm
                isOpen={openCreatePopUp}
                onClose={() => setOpenCreatePopUp(false)}
                title="Create Business"
                onSubmit={handleSubmit}
                fields={[
                    { name: "business_name", label: "Business Name", required: true },
                    { name: "business_address", label: "Business Address", required: true },
                    { name: "gstin", label: "GSTIN", required: true },
                    { name: "state_code", label: "State Code", required: true },
                    // { name: "business_logo", label: "Logo" },
                    // { name: "business_website_url", label: "Website" },
                    // { name: "", label: "Support Email" },
                    // { name: "business_bank_details", label: "Bank Details" },
                    // { name: "business_signature", label: "Signature" },
                ]}
            />

            {/* Confirm before Delete any record PopUp */}
            <ModalPopup
                isOpen={openDeletePopUp}
                onClose={() => setOpenDeletePopUp(false)}
                title="Delete Business"
                subtext={`Are you sure you want to delete "${selectedBusiness?.business_name}"?`}
                cancelText="Cancel"
                actionText="Delete"
                onAction={confirmDelete}
            />

            {/* Edit Form */}
            <ReusableForm
                isOpen={openEditPopUp}
                onClose={() => setOpenEditPopUp(false)}
                title="Edit Business"
                onSubmit={handleUpdate}
                initialValues={editBusiness || {}}   // ✅ AUTO FILL HERE
                fields={[
                    { name: "business_name", label: "Business Name", required: true },
                    { name: "business_address", label: "Business Address", required: true },
                    { name: "gstin", label: "GSTIN", required: true },
                    { name: "state_code", label: "State Code", required: true },
                ]}
            />
        </>
    );
};

export default ManageBusiness;
